function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable react/display-name */
import React from 'react';
import styled from 'styled-components';
import { typography, textStyle } from 'styled-system';
import { themed } from '../utils/system';
import { Box } from '../index';
var LegacyText = styled(Box)(themed('Text'), typography, textStyle);
var TEXT_TYPES = {
  H1: function H1(props) {
    return /*#__PURE__*/React.createElement(LegacyText, _extends({
      textStyle: 'header1'
    }, props));
  },
  H2: function H2(props) {
    return /*#__PURE__*/React.createElement(LegacyText, _extends({
      textStyle: 'header2'
    }, props));
  },
  H3: function H3(props) {
    return /*#__PURE__*/React.createElement(LegacyText, _extends({
      textStyle: 'header3'
    }, props));
  },
  H4: function H4(props) {
    return /*#__PURE__*/React.createElement(LegacyText, _extends({
      textStyle: 'header4'
    }, props));
  },
  H5: function H5(props) {
    return /*#__PURE__*/React.createElement(LegacyText, _extends({
      textStyle: 'header5'
    }, props));
  },
  H6: function H6(props) {
    return /*#__PURE__*/React.createElement(LegacyText, _extends({
      textStyle: 'header6'
    }, props));
  },
  Subtitle1: function Subtitle1(props) {
    return /*#__PURE__*/React.createElement(LegacyText, _extends({
      textStyle: 'subtitle1'
    }, props));
  },
  Subtitle2: function Subtitle2(props) {
    return /*#__PURE__*/React.createElement(LegacyText, _extends({
      textStyle: 'subtitle2'
    }, props));
  },
  Body1: function Body1(props) {
    return /*#__PURE__*/React.createElement(LegacyText, _extends({
      textStyle: 'body'
    }, props));
  },
  Body2: function Body2(props) {
    return /*#__PURE__*/React.createElement(LegacyText, _extends({
      textStyle: 'small'
    }, props));
  },
  Caption: function Caption(props) {
    return /*#__PURE__*/React.createElement(LegacyText, _extends({
      textStyle: 'caption'
    }, props));
  }
};
Object.keys(TEXT_TYPES).forEach(function (type) {
  LegacyText[type] = TEXT_TYPES[type];
  LegacyText[type].displayName = type;
});
LegacyText.TEXT_TYPES = TEXT_TYPES;
export { LegacyText, TEXT_TYPES };
export default LegacyText;